import React from 'react';
import { motion } from 'framer-motion';
interface ColorOption {
  id: string;
  name: string;
  hex: string;
}
interface ColorSelectorProps {
  colors: ColorOption[];
  selectedColor: string;
  onSelectColor: (colorId: string) => void;
}
export function ColorSelector({
  colors,
  selectedColor,
  onSelectColor
}: ColorSelectorProps) {
  return <div className="flex items-center gap-6" data-id="element-20">
      <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-21">
        Color
      </h2>
      <div className="flex gap-3" data-id="element-22">
        {colors.map(color => {
        const isSelected = selectedColor === color.id;
        return <motion.button key={color.id} onClick={() => onSelectColor(color.id)} className="relative group" whileHover={{
          scale: 1.1
        }} whileTap={{
          scale: 0.95
        }} data-id="element-23">
              <div className={`
                  w-12 h-12 rounded-full border-2 transition-all
                  ${isSelected ? 'border-black shadow-lg' : 'border-gray-300 group-hover:border-gray-400'}
                `} style={{
            backgroundColor: color.hex
          }} data-id="element-24" />
              {isSelected && <motion.div layoutId="activeColor" className="absolute inset-0 rounded-full border-2 border-black" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-25" />}
              <span className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs text-gray-600 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-26">
                {color.name}
              </span>
            </motion.button>;
      })}
      </div>
    </div>;
}